export default __webpack_public_path__ + "static/media/program_deadline.7131d398.jpeg";